import Form from "react-bootstrap/Form";
import "../../../src/main.css";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import CopyIcon from "assets/img/illustrations/CopyIcon";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { Carousel } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Image, Row } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";

import Offcanvas from "react-bootstrap/Offcanvas";
import CardDiv from "modules/common/card-div/CardDiv";
import SoftBadge from "modules/common/SoftBadge";

function OffCanvas({ ...props }) {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loadData, setLoadData] = useState(null);
  const [count, setCount] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const handleImageClick = (image, index) => {
    const clickedImage = image[index];
    const updatedImageArray = [
      clickedImage,
      ...image.slice(0, index),
      ...image.slice(index + 1),
    ];
    setSelectedImage(updatedImageArray);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
  };

  let updateData = props.rowData?.history?.map((item) => {
    return (
      <div className="my-2 ">
        <CardDiv
          title={<span className="fs-1"> {item?.event}</span>}
          component={
            <>
              <div className="text-black">{item?.description}</div>
              <div>
                <span className="fw-bold"> Author: </span>
                {item?.action_taker?.first_name}
              </div>
              <div>
                {" "}
                <span className="fw-bold">Created At: </span>
                {moment(item?.created_at, "YYYY/MM/DD HH:mm:ss").format(
                  "DD/MM/YYYY HH:mm:ss"
                )}
              </div>
            </>
          }
        />
      </div>
    );
  });

  const handleLoad = () => {
    if (count == 0) {
      setLoadData(updateData.slice(0, 4));
      setCount(count + 4);
    } else {
      setLoadData(updateData.slice(0, count + 2));
      setCount(count + 2);
    }
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div variant="primary" onClick={handleShow} className="me-2">
        <CopyIcon color={props.color} />
      </div>
      <Offcanvas
        show={show}
        style={{ width: "25vw", zIndex: "9999" }}
        onHide={handleClose}
        {...props}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Ticket Created</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <SoftBadge bg="info" style={{ fontSize: 10 }} className="p-3 fs-1">
            Ticket: #{props?.id}
          </SoftBadge>
          <SoftBadge bg="info" className="p-3 fs-1">
            {props?.rowData[0]?.action_taker?.phone_number}
          </SoftBadge>
          <div className="mt-3">
            {loadData ? loadData : updateData.slice(0, 2)}
            <div
              onClick={handleLoad}
              className="text-center mt-3 text-primary cursor-pointer"
            >
              Load more...
            </div>
            <div className="mt-4 d-flex flex-wrap gap-3">
              <Row justify="center" className="mt-2 scalpImgCon">
                <Image.PreviewGroup>
                  {props?.rowData?.images?.map((image, index) => {
                    if (image) {
                      if (!image?.includes(".pdf")) {
                        return (
                          <p>
                            <img
                              key={index}
                              height={112}
                              src={image}
                              width={112}
                              onClick={() =>
                                handleImageClick(props.rowData.images, index)
                              }
                            />
                          </p>
                        );
                      } else return null;
                    }
                  })}
                  {props?.rowData?.images?.map((image, index) => {
                    if (image) {
                      let name = image?.split("?")[0] || null;
                      name = name ? name.split("/") : null;
                      name = name ? name[name.length - 1] : null;
                      name = "PDF: " + name.substring(0, 10) + "...";
                      if (image.includes(".pdf")) {
                        return (
                          <p>
                            <Card
                              style={{
                                width: "105px",
                                height: "110px",
                              }}
                              bordered
                              hoverable
                            >
                              <a href={image} target="_blank">
                                <FilePdfOutlined style={{ fontSize: "400%" }} />
                              </a>
                            </Card>
                          </p>
                        );
                      } else return null;
                    }
                  })}
                </Image.PreviewGroup>
              </Row>
            </div>

            <Modal
              show={selectedImage !== null}
              onHide={closeImageModal}
              size={"md"}
            >
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>
                <div style={{ width: "100%", height: "100%" }}>
                  {selectedImage && (
                    <Carousel
                      className="theme-slider"
                      nextIcon={<FontAwesomeIcon icon="angle-right" />}
                      prevIcon={<FontAwesomeIcon icon="angle-left" />}
                      style={{ backgroundColor: "grey" }}
                    >
                      {selectedImage?.map((item) => (
                        <Carousel.Item key={item}>
                          <img
                            className="d-block w-100"
                            src={item}
                            alt="Slide"
                            style={{
                              width: "30vh",
                              height: "60vh",
                              objectFit: "contain",
                            }}
                          />
                        </Carousel.Item>
                      ))}
                    </Carousel>
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer></Modal.Footer>
            </Modal>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

function CopyAction(props) {
  return (
    <>
      <OffCanvas
        key={6}
        color={props.color}
        placement={"end"}
        rowData={props.rowData}
        id={props.id}
        name={"Filter"}
      />
    </>
  );
}

export default CopyAction;
